export const BOT_MOVE_DELAY = 4000;
export const BOT_HARD_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE = 70;
export const BOT_EASY_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE = 0;
export const BOT_HARD_MOD_INCORRECT_QUIZ_PROBABILITY_PERCENTAGE = 100 - BOT_HARD_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE;
export const BOT_EASY_MODE_INCORRECT_QUIZ_PROBABILITY_PERCENTAGE = 100 - BOT_EASY_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE;
export const BOT_EASY_MODE_QUIZ_CARD_PROBABILITY_PERCENTAGE = 100;
export const BOT_REGULAR_CARD_DELAY = 4000;
export const BOT_ENERGY_CARD_CORRECT_ANS_DELAY = 5000;
export const BOT_ENERGY_CARD_INCORRECT_ANS_DELAY = BOT_ENERGY_CARD_CORRECT_ANS_DELAY - 1000;